import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Keycloak from 'keycloak-js';
import { catchError, from, map, mergeMap, of } from 'rxjs';
import { LoadUser, LoadUserFailure, LoadUserSuccess, Logout, LogoutFailure, LogoutSuccess } from '../actions/user.actions';
import { UserManagementControllerService } from '@iota/inh-core-v1-management-client';

@Injectable()
export class UserEffects {
    loadUser$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadUser),
            mergeMap(() =>
                this.inhCore.me().pipe(
                    map((user) => LoadUserSuccess({ user })),
                    catchError((error) => of(LoadUserFailure({ error })))
                )
            )
        )
    );

    logout$ = createEffect(() =>
        this.actions$.pipe(
            ofType(Logout),
            mergeMap(() =>
                from(this.keycloak.logout({ redirectUri: new URL('.', document.baseURI).href })).pipe(
                    map(() => LogoutSuccess()),
                    catchError((error) => of(LogoutFailure({ error })))
                )
            )
        )
    );

    constructor(
        private actions$: Actions,
        private keycloak: Keycloak,
        private inhCore: UserManagementControllerService
    ) {}
}
